import { useEffect } from "react";

export const AutoFillLatLong = ({ values, setFieldValue,data }) => {
     const {  camp_pin_code } = values;
    const {state,district,mandal,panchayat} = data;
  useEffect(() => {
   
console.log("Values ==========> ",state,district,panchayat,mandal)
    // run only when all fields are filled
   if (
  state == null ||
  district == null ||
  mandal == null ||
  panchayat == null
) return;
console.log("hike")
    const fetchLatLong = async () => {
        console.log("heyyyy")
      try {
const address = `${panchayat}, ${mandal}, ${district}, ${state}, ${camp_pin_code}`;
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`,
          {
            headers: {
              "User-Agent": "MyApp/1.0 (contact@yourdomain.com)",
            },
          }
        );
        const data = await response.json();
console.log("============================== hike ================================");
console.log(data)
        if (data.length > 0) {
          const lat = parseFloat(data[0].lat);
          const lng = parseFloat(data[0].lon);

          setFieldValue("current_latitude", `${lat}`);
          setFieldValue("current_longitude", `${lng}`);
        }
      } catch (err) {
        console.error("Lat/Lng Fetch Error:", err);
      }
    };

    fetchLatLong();
  }, [
    values,
    camp_pin_code,
    panchayat,
    state,district,mandal
  ]);

  return null; // component renders nothing
};
